export default __webpack_public_path__ + "static/media/2nd.ed331aeb.jpg";